module.exports = __webpack_public_path__ + "static/media/unavailablePage.bfe28b8d.png";